// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconCancelPath = 'M10 18a7.954 7.954 0 0 1-4.897-1.688L16.312 5.103A7.954 7.954 0 0 1 18 10c0 4.411-3.589 8-8 8Zm-8-8c0-4.411 3.589-8 8-8 1.846 0 3.543.634 4.897 1.688L3.688 14.897A7.946 7.946 0 0 1 2 10Zm8-10C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0Z';
var IconCancel = baseIcon('IconCancel', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconCancelPath
});
export default IconCancel;
//# sourceMappingURL=index.js.map